import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../actions/globalAction';
import { bezugAnalyse } from '../components/objects/bezugAnalyse';
import { Bar } from 'react-chartjs-2';
import { Card, Row, Col, Alert } from 'react-bootstrap';
import { getThemeColors } from '../utils/chartTheme';

/* ------------------------------------------------------------------ */
/*  Container                                                         */
/* ------------------------------------------------------------------ */

class BezugAnalyse extends Component {
    componentDidMount() {
        this.ladeDaten();
    }

    ladeDaten() {
        var jetzt = new Date().getFullYear();
        bezugAnalyse.BezugsAnalyseClass.url =
            bezugAnalyse.BezugsAnalyseClass.defaultSegment +
            '/jahreswerte?startYear=2011&endYear=' + jetzt;
        bezugAnalyse.BezugsAnalyseClass.forceRefresh = true;

        bezugAnalyse.BezugsKpiClass.url =
            bezugAnalyse.BezugsKpiClass.defaultSegment +
            '/kpi?startYear=2011&endYear=' + jetzt;
        bezugAnalyse.BezugsKpiClass.forceRefresh = true;

        this.props.request(bezugAnalyse.BezugsAnalyseClass);
        this.props.request(bezugAnalyse.BezugsKpiClass);
    }

    render() {
        return <div>{this.renderContent()}</div>;
    }

    renderContent() {
        var data = this.props.bezugAnalyseData;
        var kpi = this.props.bezugKpi;
        var isLoaded = this.props.isLoaded;

        if (!isLoaded) {
            return (
                <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Laden...</span>
                    </div>
                    <p className="mt-3 text-muted">Strombezug-Daten werden geladen...</p>
                </div>
            );
        }

        if (!data || !data.jahreswerte || data.jahreswerte.length === 0) {
            return (
                <Card className="mb-3">
                    <Card.Body className="text-center py-4">
                        <i className="bi bi-info-circle me-1" />{' '}
                        Keine Strombezug-Daten im gewaehlten Zeitraum verfuegbar.
                    </Card.Body>
                </Card>
            );
        }

        return (
            <div className="strombezug-analyse">
                <KpiKacheln kpi={kpi} jahrAnzahl={data.jahreswerte.length} />
                <BezugsDiagramm jahreswerte={data.jahreswerte} />
                <MonatsTabelle monatlich={data.monatsDurchschnitt} />
                <BatterieSchaezung monatlich={data.monatsDurchschnitt} />
            </div>
        );
    }
}

/* ------------------------------------------------------------------ */
/*  Formatierung                                                       */
/* ------------------------------------------------------------------ */

function fmt(val, decimals) {
    if (val === null || val === undefined) return '—';
    try {
        return Number(val).toLocaleString('de-DE', {
            minimumFractionDigits: decimals || 0,
            maximumFractionDigits: decimals || 1,
        });
    } catch (_) {
        return String(val);
    }
}

/* ------------------------------------------------------------------ */
/*  KPI-Kacheln                                                        */
/* ------------------------------------------------------------------ */

function KpiKacheln({ kpi, jahrAnzahl }) {
    if (!kpi) return null;

    var items = [
        // Kachel 1: Gesamtbezug
        {
            label: 'Gesamtbezug',
            value: fmt(kpi.gesamtBezugKwh, 0),
            unit: ' kWh',
            icon: '⚡',
        },
        // Kachel 2: Durchschnitt pro Jahr
        {
            label: 'Durchschnitt / Jahr',
            value: fmt(kpi.durchschnittProJahr, 0),
            unit: ' kWh',
            icon: '📅',
        },
        // Kachel 3: Monat mit hoechstem Bezug (Durchschnitt)
        {
            label: 'Meiste Bezug im:',
            value: kpi.hoechsterMonatName || '—',
            unit: '\n(' + fmt(kpi.hoechsterMonatKwh, 0) + ' kWh Ø/Monat)',
            icon: '🔼',
        },
        // Kachel 4: Zeitraum mit Jahrspanne
        {
            label: 'Zeitraum',
            value: jahrAnzahl || 0,
            unit: ' Jahre',
            icon: '📊',
        },
    ];

    return (
        <Row className="mb-3">
            {items.map(function (item, i) {
                var unitLines = (item.unit || '').split('\n');
                return (
                    <Col key={i} xs={6} md={3} className="mb-2">
                        <div className="kpi-card">
                            <div className="kpi-card-icon">{item.icon}</div>
                            <div className="kpi-card-content">
                                <div className="kpi-card-value">
                                    {item.value}
                                    {unitLines[0] && (
                                        <span className="kpi-card-unit">{unitLines[0]}</span>
                                    )}
                                </div>
                                {unitLines[1] && (
                                    <div className="kpi-card-subtitle" style={{ fontSize: '0.72rem', color: '#6c757d' }}>
                                        {unitLines[1]}
                                    </div>
                                )}
                                <div className="kpi-card-label">{item.label}</div>
                            </div>
                        </div>
                    </Col>
                );
            })}
        </Row>
    );
}

/* ------------------------------------------------------------------ */
/*  Balkendiagramm - Jährlicher Bezug                                   */
/* ------------------------------------------------------------------ */

var BEZUG_BAR = 'rgba(220, 53, 69, 0.70)';
var BEZUG_BORDER = 'rgba(220, 53, 69, 0.90)';
var DURCHSCHNITT_LINE = 'rgba(13, 202, 240, 0.85)';

function BezugsDiagramm({ jahreswerte }) {
    var labels = jahreswerte.map(function (j) { return String(j.jahr); });
    var barData = jahreswerte.map(function (j) { return j.bezugKwh; });

    var gesamt = jahreswerte.reduce(function (s, j) { return s + j.bezugKwh; }, 0);
    var durchschn = gesamt / jahreswerte.length;
    var lineData = jahreswerte.map(function () { return durchschn; });

    return (
        <Card className="chart-card mb-3">
            <Card.Body>
                <h6 className="card-title text-center mb-3">
                    Jährlicher Strombezug aus dem Netz (kWh)
                </h6>
                <Bar data={buildChartData(labels, barData, lineData)} options={buildChartOptions()} />
            </Card.Body>
        </Card>
    );
}

function buildChartData(labels, bars, line) {
    return {
        labels: labels,
        datasets: [
            {
                type: 'line',
                label: 'Ø pro Jahr',
                data: line,
                borderColor: DURCHSCHNITT_LINE,
                backgroundColor: DURCHSCHNITT_LINE,
                borderWidth: 2,
                borderDash: [6, 4],
                pointRadius: 0,
                fill: false,
                order: 0,
            },
            {
                type: 'bar',
                label: 'Bezug (kWh)',
                data: bars,
                backgroundColor: BEZUG_BAR,
                borderColor: BEZUG_BORDER,
                borderWidth: 1,
                borderRadius: 3,
                barPercentage: 0.72,
                categoryPercentage: 0.82,
                order: 1,
            },
        ],
    };
}

function buildChartOptions() {
    var tc = getThemeColors();
    return {
        responsive: true,
        maintainAspectRatio: true,
        aspectRatio: 2.2,
        interaction: { mode: 'index', intersect: false },
        plugins: {
            datalabels: { display: false },
            tooltip: {
                backgroundColor: 'rgba(33,37,41,0.92)',
                titleColor: '#e4e6ea',
                bodyColor: '#e4e6ea',
                padding: 10,
                cornerRadius: 8,
                callbacks: {
                    label: function (ctx) {
                        var val = ctx.raw;
                        if (val === null || val === undefined) return '';
                        var dsLabel = ctx.dataset.label || '';
                        return dsLabel + ': ' + Number(val).toLocaleString('de-DE', { maximumFractionDigits: 0 }) + ' kWh';
                    },
                },
            },
            legend: { display: false },
        },
        scales: {
            x: {
                grid: { color: tc.gridColor, drawBorder: false },
                ticks: { maxRotation: 0, color: tc.textColor },
                title: { display: true, text: 'Jahr', color: tc.textColor },
            },
            y: {
                grid: { color: tc.gridColor, drawBorder: false },
                beginAtZero: true,
                ticks: {
                    color: tc.textColor,
                    callback: function (v) { return Number(v).toLocaleString('de-DE', { maximumFractionDigits: 0 }); },
                },
                title: { display: true, text: 'kWh', color: tc.textColor },
            },
        },
    };
}

/* ------------------------------------------------------------------ */
/*  Monatsvergleich-Tabelle                                            */
/* ------------------------------------------------------------------ */

function MonatsTabelle({ monatlich }) {
    if (!monatlich || monatlich.length === 0) return null;

    var thCls = 'px-2 py-1 text-center border align-middle';
    var tdCls = 'px-2 py-1 text-center border align-middle';

    return (
        <Card className="chart-card mb-3">
            <Card.Body>
                <h6 className="card-title text-center mb-1">
                    Bezug pro Monat — Durchschnitt, Minimum und Maximum
                </h6>
                <p className="text-muted text-center small mb-3">
                    Fuer jeden Monat wird der durchschnittliche Netzbezug aller analysierten Jahre angezeigt.
                    Dazu das niedrigste und hoechste einzelne Monatsergebnis mit dem jeweiligen Jahr.
                </p>
                <div className="table-responsive">
                    <table className="table table-sm table-hover mb-0">
                        <thead>
                            <tr style={{ fontWeight: 600, fontSize: '0.82rem' }}>
                                <th className={thCls}>Monat</th>
                                <th className={thCls}>Ø Bezug (kWh)</th>
                                <th className={thCls}>Geringster Bezug (kWh)</th>
                                <th className={thCls}>in Jahr</th>
                                <th className={thCls}>Hoechster Bezug (kWh)</th>
                                <th className={thCls}>in Jahr</th>
                            </tr>
                        </thead>
                        <tbody>
                            {monatlich.map(function (m, i) {
                                return (
                                    <tr key={i} style={{ fontSize: '0.85rem' }}>
                                        <td className={tdCls}>{m.monatsname}</td>
                                        <td className={tdCls}>{fmt(m.durchschnKwh, 1)}</td>
                                        <td className={tdCls}>{fmt(m.minKwh, 1)}</td>
                                        <td className={tdCls}>{m.minJahr}</td>
                                        <td className={tdCls}>{fmt(m.maxKwh, 1)}</td>
                                        <td className={tdCls}>{m.maxJahr}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </Card.Body>
        </Card>
    );
}

/* ------------------------------------------------------------------ */
/*  Batteriespeicher-Schaetzung                                        */
/* ------------------------------------------------------------------ */

function BatterieSchaezung({ monatlich }) {
    if (!monatlich || monatlich.length === 0) return null;

    // Finde den Monat mit hoechstem Durchschnittsbezug (in der Regel Winter)
    var hoechstMonat = monatlich.reduce(function (max, m) {
        return !max || m.durchschnKwh > max.durchschnKwh ? m : max;
    }, null);

    if (!hoechstMonat) return null;

    // Hoechster Monatsbezug in kWh
    var maxMonatBezug = hoechstMonat.durchschnKwh;

    // Schaetzung: Wie viel Batterie Kapitaet waere sinnvoll?
    // Annahme: Eine Batterie kann im Winter ca. 30-40% des Nachtbezugs abdecken.
    // Der hoechste Monat ist der Massstab fuer die groesste Ersparnis.
    // Faustformel: Batterie ca. 50-70% des hoechsten Monatsbezugs (pro Tag gerechnet)

    var tageImMonat = getTageFuerMonat(hoechstMonat.monat);
    var bezugProTag = maxMonatBezug / tageImMonat;

    // Eine gute Batterie sollte 1-2 Tage des hoechsten Bezugs puffern koennen
    var batteriemini = Math.round(bezugProTag * 1.5 * 10) / 10;
    var batterieoptimal = Math.round(bezugProTag * 2.5 * 10) / 10;

    // Auf handelsuebliche Werte runden (8, 10, 13.5, 14.7, 16, 20 kWh)
    var handelswerte = [8, 10, 12, 13.5, 14.7, 16, 20, 27];
    var empfohlen = null;
    for (var i = 0; i < handelswerte.length; i++) {
        if (handelswerte[i] >= batterieoptimal) {
            empfohlen = handelswerte[i];
            break;
        }
    }
    if (!empfohlen) empfohlen = handelswerte[handelswerte.length - 1];

    // Wie viel Prozent des hoechsten Monatsbezugs waere abdeckbar?
    var abdeckbarProzent = Math.round((empfohlen * 0.7 / tageImMonat / bezugProTag) * 100);
    if (abdeckbarProzent > 60) abdeckbarProzent = 55; // realistische Obergrenze

    return (
        <Card className="chart-card mb-3">
            <Card.Body>
                <h6 className="card-title text-center mb-1">
                    <i className="bi bi-battery-charging me-1" />
                    Batteriespeicher-Schaetzung
                </h6>
                <p className="text-muted text-center small mb-3">
                    Basierend auf Ihrem hoechsten Monatsbezug ({hoechstMonat.monatsname}: {fmt(maxMonatBezug, 0)} kWh Ø)
                </p>

                <Row className="mb-3">
                    <Col xs={6} md={4}>
                        <div className="text-center">
                            <div style={{ fontSize: '1.4rem', fontWeight: 700 }}>
                                {fmt(bezugProTag, 1)} kWh
                            </div>
                            <div className="small text-muted">Ihr tgl. Bezug im {hoechstMonat.monatsname}</div>
                        </div>
                    </Col>
                    <Col xs={6} md={4}>
                        <div className="text-center">
                            <div style={{ fontSize: '1.4rem', fontWeight: 700 }}>
                                {empfohlen} kWh
                            </div>
                            <div className="small text-muted">Empfohlene Batteriegroeße</div>
                        </div>
                    </Col>
                    <Col xs={12} md={4}>
                        <div className="text-center">
                            <div style={{ fontSize: '1.4rem', fontWeight: 700 }}>
                                ca. {abdeckbarProzent}%
                            </div>
                            <div className="small text-muted">Einsparpotenzial im {hoechstMonat.monatsname}</div>
                        </div>
                    </Col>
                </Row>

                <Alert variant="info" className="small mb-0">
                    <strong>Hintergrund:</strong> Ihr hoechster Netzbezug liegt im{' '}
                    <strong>{hoechstMonat.monatsname}</strong> mit durchschnittlich{' '}
                    {fmt(maxMonatBezug, 0)} kWh pro Monat ({fmt(bezugProTag, 1)} kWh pro Tag).<br />
                    Eine Batterie mit ca. <strong>{empfohlen} kWh</strong> koennte im Winter etwa{' '}
                    <strong>{abdeckbarProzent}%</strong> des tgl. Bezugs puffern (PV-Tagesproduktion + Speicherung).<br />
                    <span className="text-muted">
                        Dies ist eine grobe Schaezung. Die tatsaechliche Einsparung haengt von PV-Leistung,
                        Verbrauchsverteilung (Tag/Nacht), Witterung und Ladestrategie ab.
                    </span>
                </Alert>
            </Card.Body>
        </Card>
    );
}

// Tage pro Monat (vereinfacht)
function getTageFuerMonat(monat) {
    var tage = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    return tage[monat - 1] || 30;
}

/* ------------------------------------------------------------------ */
/*  Redux                                                               */
/* ------------------------------------------------------------------ */

export default connect(
    function (state) { return state.bezugAnalyseReducer; },
    function (dispatch) { return bindActionCreators(actionCreators, dispatch); }
)(BezugAnalyse);
